.actions,
.status {
  display: flex;
  align-items: center;
  gap: var(--space-md);
}

.status {
  line-height: 1;
}
